import "../../../../design/cooperateWithUs.css";
import Footer from "../Footer";
import PartnerCompanies from "../../../../utils/components/PartnerCompanies";
import Contact from "./Contact";
import { motion } from "framer-motion";

const plans = [
    { name: "ბაზისური", price: "100", period: "თვეში" },
    { name: "პლიუსი", price: "250", period: "თვეში", promo: "პოპულარული", featured: true },
    { name: "პრემიუმი", price: "400", period: "თვეში" }
];

const features = [
    { title: "ლოგო პარტნიორებში", desc: "თქვენი ლოგო მთავარ გვერდზე", values: ["✔", "✔", "✔"] },
    { title: "ბრენდის სახელი", desc: "სახელის ჩვენება ლოგოსთან ერთად", values: ["✔", "✔", "✔"] },
    { title: "დიდი ზომის რეკლამა", desc: "მაქსიმალური ხილვადობა მთავარ სივრცეში", values: ["—", "—", "✔"] },
    { title: "საშუალო ზომის რეკლამა", desc: "ეფექტური ბანერი პლატფორმის შუაგულში", values: ["—", "✔", "✔"] },
    { title: "პატარა ზომის რეკლამა", desc: "მცირე ბანერი შიდა გვერდებზე", values: ["✔", "✔", "✔"] },
    { title: "Facebook მხარდაჭერა", desc: "რეკლამირება სოციალურ ქსელებში", values: ["—", "✔", "✔"] },
];

export default function CooperateWithUs() {
    const handleScrollTo = (anchor) => {
        document.querySelector(anchor)?.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <>
            <div className="pricing-container">
                <div className="navbar-spacer"></div>

                <motion.div
                    initial={{ opacity: 0, y: 15 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="pricing-header"
                >
                    <span className="pricing-badge">პარტნიორობა</span>
                    <h1>ტარიფები და შესაძლებლობები</h1>
                    <p>გახდი ჩვენი პლატფორმის ნაწილი და მიაწვდინე ხმა ათასობით მშობელსა და მასწავლებელს.</p>
                </motion.div>

                {/* STANDARD PRICING TABLE */}
                <div className="pricing-table-wrapper">
                    <table className="pricing-table">
                        <thead>
                        <tr>
                            <th className="feature-col">შესაძლებლობები</th>
                            {plans.map((plan, i) => (
                                <th key={i} className={plan.featured ? "featured-th" : ""}>
                                    <div className="plan-card-header">
                                        {plan.promo && <span className="promo-tag">{plan.promo}</span>}
                                        <h3>{plan.name}</h3>
                                        <div className="price-tag">
                                            <span className="amount">{plan.price}</span>
                                            <span className="currency">₾</span>
                                            <span className="period">/{plan.period}</span>
                                        </div>
                                    </div>
                                </th>
                            ))}
                        </tr>
                        </thead>
                        <tbody>
                        {features.map((feature, i) => (
                            <tr key={i}>
                                <td className="feature-info">
                                    <strong>{feature.title}</strong>
                                    <span>{feature.desc}</span>
                                </td>
                                {feature.values.map((val, j) => (
                                    <td key={j} className={val === "✔" ? "check-cell" : "dash-cell"}>
                                        {val === "✔" ? "✔" : "—"}
                                    </td>
                                ))}
                            </tr>
                        ))}
                        </tbody>
                        <tfoot>
                        <tr>
                            <td className="feature-info"></td>
                            {plans.map((_, i) => (
                                <td key={i}>
                                    <button className="plan-btn" onClick={() => handleScrollTo("#contact")}>
                                        დაწყება
                                    </button>
                                </td>
                            ))}
                        </tr>
                        </tfoot>
                    </table>
                </div>

                {/* OVERPAID PREMIUM SECTION */}
                <div className="overpaid-section">
                    <div className="overpaid-header">
                        <span className="overpaid-badge">PREMIUM PRIORITY</span>
                        <h2>Overpaid ტარიფები 🔥</h2>
                        <p>მათთვის, ვისაც სურს მაქსიმალური პრიორიტეტი, რეკლამის 100%-იანი ხილვადობა ან სრული ექსკლუზივი პლატფორმაზე.</p>
                    </div>

                    <div className="overpaid-grid">
                        {/* Level 1 */}
                        <div className="overpaid-card">
                            <div className="overpaid-level">LEVEL 1</div>
                            <h3>პრიორიტეტული რანდომიზაცია</h3>
                            <p className="overpaid-desc">
                                ზრდის თქვენი რეკლამის ჩვენების შანსს (პროცენტულობას) საერთო სარეკლამო ბადეში სხვა სტანდარტულ დამკვეთებთან შედარებით.
                            </p>
                            <div className="overpaid-price">
                                600<span className="currency">₾</span><span className="period">/თვეში</span>
                            </div>
                            <button className="overpaid-btn" onClick={() => handleScrollTo("#contact")}>შეკვეთა</button>
                        </div>

                        {/* Level 2 */}
                        <div className="overpaid-card high-priority">
                            <div className="overpaid-level gold-level">LEVEL 2</div>
                            <h3>100% ექსკლუზიური ადგილი</h3>
                            <p className="overpaid-desc">
                                იღებთ გარანტირებულ, მუდმივ 100%-იან ჩვენებას ერთ კონკრეტულ სარეკლამო პოზიციაზე (რეკომენდებულია დიდი ზომის ბანერი).
                            </p>
                            <div className="overpaid-price contact-price">
                                ინდივიდუალური
                            </div>
                            <button className="overpaid-btn gold-btn" onClick={() => handleScrollTo("#contact")}>კონსულტაცია</button>
                        </div>

                        {/* Level 3 */}
                        <div className="overpaid-card ultimate-priority">
                            <div className="overpaid-level diamond-level">LEVEL 3</div>
                            <h3>სრული მონოპოლია (Full Takeover)</h3>
                            <p className="overpaid-desc">
                                პლატფორმის ყველა სარეკლამო სივრცის სრული ბლოკირება მხოლოდ თქვენი ბრენდისთვის. სხვა არცერთი რეკლამა საიტზე არ გამოჩნდება.
                            </p>
                            <div className="overpaid-price contact-price">
                                ინდივიდუალური
                            </div>
                            <button className="overpaid-btn diamond-btn" onClick={() => handleScrollTo("#contact")}>დაკავშირება</button>
                        </div>
                    </div>

                    {/* Level 3 Warning Alert (UPDATE: Removed 10% bonus mention) */}
                    <div className="overpaid-warning-box">
                        <div className="warning-title">
                            ⚠️ LEVEL 3 - მნიშვნელოვანი ინფორმაცია გამოთვლის წესზე:
                        </div>
                        <p>
                            მონოპოლიის (Level 3) ღირებულება ინდივიდუალურად იანგარიშება <strong>TeacherHub</strong>-ის მიერ კერძო კომუნიკაციისას.
                            ფასი ფორმირდება იმ აქტიური კლიენტების რაოდენობის მიხედვით, რომელთა რეკლამაც უნდა ჩამოიხსნას:
                            სისტემა ითვლის მათ მიერ გამოუყენებელ სარეკლამო დღეებს, უბრუნებს მათ შესაბამის ნაშთს (გადახდილ თანხას)
                            და ეს ჯამური დასაბრუნებელი თანხა ემატება Level 3-ის პაკეტის საბაზისო საფასურს.
                        </p>
                    </div>
                </div>

                {/* ADS LOGIC SECTION (UPDATE: Removed 10% bonus mention and updated example) */}
                <div className="ads-logic-section">
                    <h2 className="section-title-small">როგორ მუშაობს სარეკლამო სისტემა?</h2>

                    <div className="logic-grid">
                        <div className="logic-card">
                            <div className="logic-icon">📅</div>
                            <h4>30-დღიანი პერიოდი</h4>
                            <p>ყველა ტიპის სარეკლამო განთავსება მოქმედებს სტანდარტული 30 კალენდარული დღის განმავლობაში.</p>
                        </div>

                        <div className="logic-card">
                            <div className="logic-icon">🎲</div>
                            <h4>რანდომიზაციის პრინციპი</h4>
                            <p>თუ მოთხოვნა აჭარბებს თავისუფალ ადგილებს, სისტემა ავტომატურად ანაცვლებს რეკლამებს შემთხვევითობის პრინციპით.</p>
                        </div>

                        <div className="logic-card highlighted-card">
                            <div className="logic-icon">🔄</div>
                            <h4>თანხის დაბრუნების გარანტია</h4>
                            <p>თუ თქვენი ადგილი სხვა დამკვეთმა დაიკავა ვადაზე ადრე, დაგიბრუნებთ მხოლოდ გამოუყენებელი დღეების პროპორციულ საფასურს.</p>
                            <div className="example-box">
                                <strong>მაგალითი:</strong> მონოპოლიის შეკვეთისას ყველა კომპანიას ვისაც აქტიური რეკლამა აქვს დავუბრუნებთ გამოუყენებლი დღეების შესაბამისი რაოდენობის თანხას.
                            </div>
                        </div>
                    </div>
                    <p className="logic-note">* წესი არ ვრცელდება "Overpaid" სერვისით შეკვეთილ პრიორიტეტულ რეკლამებზე.</p>
                </div>

                <PartnerCompanies />
            </div>

            <Contact />
            <Footer />
        </>
    );
}